/**
 * Formato de presentacion.
 *
 * El dinero vive en enteros de centavos en toda la plataforma. `dinero()` es
 * el UNICO lugar donde se divide entre cien: un solo redondeo, al presentar.
 */

const FORMATO_MX = new Intl.NumberFormat('es-MX', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export function dinero(centavos: number | null | undefined, moneda = 'MXN'): string {
  if (centavos === null || centavos === undefined) return '—';
  return `$${FORMATO_MX.format(centavos / 100)} ${moneda}`;
}

export function entero(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  return new Intl.NumberFormat('es-MX').format(n);
}

export function porcentaje(n: number | null | undefined): string {
  if (n === null || n === undefined) return '—';
  return `${FORMATO_MX.format(n)}%`;
}

export function fecha(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-MX', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function fechaHora(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('es-MX', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function iniciales(nombre: string): string {
  return nombre
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0] ?? '')
    .join('')
    .toUpperCase();
}

/**
 * Un valor de origen desconocido, como texto.
 *
 * Existe porque las piezas declarativas reciben filas como
 * `Record<string, unknown>`: la columna sabe su nombre, no su tipo. `String()`
 * sobre un valor desconocido produce "[object Object]" en cuanto llega un
 * jsonb, y eso es justo lo que no puede aparecer en una celda. Aqui cada
 * forma se trata por separado y el objeto se serializa a proposito.
 */
export function aTexto(v: unknown): string {
  if (v === null || v === undefined) return '';
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'bigint') return v.toString();
  if (typeof v === 'boolean') return v ? 'Si' : 'No';
  if (v instanceof Date) return v.toISOString();
  /* Un jsonb de la auditoria, o un arreglo de series. Se serializa en vez de
     esconderse: un valor que no se puede leer igual tiene que poder verse. */
  return JSON.stringify(v) ?? '';
}
